
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as aboutbpeB0pHlp_SDPgddjTg8KQ6dzjZQ2TOcvb_45TtdyW5kwMeta } from "/workspace/pages/about.vue?macro=true";
import { default as indexidyDttn2nAtfyKcnzRUSqhwnL7kztssg1Rdvj0_45dfSAMeta } from "/workspace/pages/index.vue?macro=true";
import { default as contactFj0aNoRPJSXxj4SXLABzquCnprKOdtFKISUHdP_nOroMeta } from "/workspace/pages/contact.vue?macro=true";
import { default as _91id_93pJGBFcupVQF5CIC1s9Trh1GvPKjOFqXgy5sPT4GLLiQMeta } from "/workspace/pages/jobs/[id].vue?macro=true";
import { default as indexpEz7T48OtRYhFw4PUjKGfAWarJ_45ncOYvxjTxlcURow8Meta } from "/workspace/pages/jobs/index.vue?macro=true";
import { default as recruitmentT_45Xk0XjWSDIubFBApgogtcF8CqXitB12ujBQ_45Y__45sxgMeta } from "/workspace/pages/recruitment.vue?macro=true";
import { default as privacy_45policyehTun0WVymz3_459ViU0ZT_45U7AgH2xis5SuclzChbG0VQMeta } from "/workspace/pages/privacy-policy.vue?macro=true";
import { default as terms_45and_45conditions45eSKV2BJIfkHzJmHIkUs0DPCfJkBajc4ebrGLubx0cMeta } from "/workspace/pages/terms-and-conditions.vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    component: () => import("/workspace/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/workspace/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/workspace/pages/contact.vue")
  },
  {
    name: "jobs-id",
    path: "/jobs/:id()",
    component: () => import("/workspace/pages/jobs/[id].vue")
  },
  {
    name: "jobs",
    path: "/jobs",
    component: () => import("/workspace/pages/jobs/index.vue")
  },
  {
    name: "recruitment",
    path: "/recruitment",
    component: () => import("/workspace/pages/recruitment.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/workspace/pages/privacy-policy.vue")
  },
  {
    name: "terms-and-conditions",
    path: "/terms-and-conditions",
    component: () => import("/workspace/pages/terms-and-conditions.vue")
  }
]